import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Link,
  Redirect,
  Route,
  Switch,
  withRouter,
  matchPath
} from "react-router-dom";
import styled from "styled-components";
import {
  Home as HomeIcon,
  // Mail as MailIcon,
  GroupWork as GroupWorkIcon,
  DateRange as DateRangeIcon,
  People as PeopleIcon,
  Error as ErrorIcon,
  ExitToApp as ExitToAppIcon,
  School as SchoolIcon,
  Mail as MailIcon,
  Settings as SettingsIcon,
  History as HistoryIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Security as SecurityIcon,
  Sync as SyncIcon,
  Lock as LockIcon,
  ViewModule as ViewModuleIcon
} from "@material-ui/icons";
import { Collapse, MenuItem, Select as MuiSelect } from "@material-ui/core";
import { bindActionCreators } from "redux";
import Hotjar from "@hotjar/browser";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import {
  setCommunicationsUnread,
  setNotificationsUnread,
  setJobsQueue
} from "./redux/actions";
import UserStore from "./utils/UserStore";
import Toolbar from "./waybee-ui/Toolbar";
import List from "./waybee-ui/List";
import ListItem from "./waybee-ui/List/ListItem";
import UserService from "./services/UserService";
import StudentService from "./services/StudentService";
import { findRoute } from "./utils/breadcrumbs";
import { clearClassDirectory } from "./utils/classDirectory";
import Login from "./views/Login/Login";
import Home from "./views/Home/Home";
import CommunicationDashboard from "./views/CommunicationDashboard/CommunicationDashboard";
import Notifications from "./views/Notifications/Notifications";
import Classes from "./views/Classes/Classes";
import ClassDetails from "./views/ClassDetails/ClassDetails";
import ClassOverview from "./views/ClassOverview/ClassOverview";
import Ocurrencces from "./views/Occurrences/Occurrences";
import ReleaseGrades from "./views/ReleaseGrades/ReleaseGrades";
import ClassSchedule from "./views/ClassSchedule/ClassSchedule";
import ClassPlan from "./views/ClassPlan/ClassPlan";
import Schedule from "./views/Schedule/Schedule";
import Teachers from "./views/Teachers/Teachers";
import TeacherDetail from "./views/TeacherDetails/TeacherDetails";
import Support from "./views/Support/Support";
import StudentProfile from "./views/StudentProfile/StudentProfile";
import StudentNotes from "./views/StudentNotes/StudentNotes";
import StudentGeneralInfo from "./views/StudentGeneralInfo/StudentGeneralInfo";
import StudentStatistics from "./views/StudentStatistics/StudentStatistics";
import StudentSchedule from "./views/StudentSchedule/StudentSchedule";
import StudentOccurrences from "./views/StudentOccurrences/StudentOccurrences";
import ClassOccurrencesAdvanced from "./views/ClassOccurrencesAdvanced/ClassOccurrencesAdvanced";
import ClassStages from "./views/ClassStages/ClassStages";
import StudentCustomMenu from "./views/StudentCustomMenu/StudentCustomMenu";
import ClassGradesV2 from "./views/ClassGradesV2/ClassGradesV2";
import RefoGrid from "./views/Refo/RefoGrid";
import GridFrequency from "./views/GridFrequency/GridFrequency";
import IndividualReport from "./views/IndividualReport/IndividualReport";
import DailySummary from "./views/DailySummary/DailySummary";
import DailySummaryList from "./views/DailySummary/DailySummaryList";
import StudentCharts from "./views/StudentCharts/StudentCharts";
import PaletteView from "./views/PaletteView/PaletteView";
import AckDialog from "./components/AckDialog";
import CommunicationService from "./services/CommunicationService";
import { AbilityContext, Can } from "./acl/can";
import { createAbility as abilityPromisse } from "./acl/ability";
import Reports from "./views/Reports/Reports";
import StudentReports from "./views/StudentReports/StudentReports";
import SmartMinutes from "./views/SmartMinutes/SmartMinutes";
import SmartMinutesList from "./views/SmartMinutes/SmartMinutesList";
import SmartMinutesDetail from "./views/SmartMinutes/SmartMinutesDetail";
import { applySmartMinutesJobWithVoice } from "./views/SmartMinutes/applySmartMinutesJob";
import AppService from "./services/AppService";
import IndividualOccurrences from "./views/IndividualOccurrences/IndividualOccurrences";
import JobsQueue from "./components/JobsQueue";
import JobsService from "./services/JobsService";
import { isJobInProgress } from "./utils/jobHelpers";
import JobRequests from "./views/JobRequests/JobRequests";
import isClassDiaryDemo from "./demo/isClassDiaryDemo";
import DemoSettings from "./views/DemoSettings/DemoSettings";
import Students from "./views/Students/Students";
import Settings from "./views/Settings/Settings";
import LbSync from "./views/Settings/LbSync/LbSync";
import GeneralBoardSettings from "./views/Settings/GeneralBoard/GeneralBoardSettings";
import ChangePassword from "./views/Login/ChangePassword";
import i18n, { applyCampusI18nOverrides } from "./utils/i18n";

const siteId = 5097720;
const hotjarVersion = 6;
const FULL_WIDTH_PATHS = ["/classes/:id/plan"];

const Select = styled(MuiSelect)`
  margin: 0;
  color: #7a7a7a;

  .MuiSelect-root {
    width: 172px;
  }

  .MuiSelect-icon {
    color: #7a7a7a;
  }
`;

const AppVersion = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.5);
  display: block;
  position: fixed;
  bottom: 8px;
  left: 8px;
`;

const SubMenuItem = styled(ListItem)`
  && {
    height: 56px;
    padding-left: 28px;
    background-color: #fafafa;
  }
`;

const SettingsMenuLabel = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

const SettingsMenuText = styled.span`
  flex: 1;
`;

const ExpandIcon = styled.span`
  display: inline-flex;
  color: #7e7e7e;
`;

class App extends Component {
  constructor() {
    super();
    this.state = {
      crumbs: [],
      routeParams: {},
      classSwitchPath: "",
      studentName: "",
      campuses: [],
      selectedCampus: "",
      pendingCommunications: [],
      communicationAttachment: [],
      openDialog: false,
      ability: null,
      settingsMenuOpen: false
    };
  }

  componentDidMount() {
    if (!UserService.isAuthenticated()) return;
    const { location, history } = this.props;

    Hotjar.init(siteId, hotjarVersion);

    history.listen(historyLocation => {
      this.setTitle(historyLocation.pathname);
    });

    this.setTitle(location.pathname);
    this.getUserCampus();
    this.getPendingAck();
    this.getExternalInfo().then(() => {
      this.loadAcl();
    });
    this.getUnreadItems();
    this.getJobsQueue();

    this.onLanguageChanged = () => {
      const { location: loc } = this.props;
      this.setTitle(loc.pathname);
    };
    i18n.on("languageChanged", this.onLanguageChanged);

    this.interval = setInterval(() => {
      const {
        jobsState: { jobs }
      } = this.props;
      const hasPendingJobs = jobs.some(job => isJobInProgress(job));
      if (hasPendingJobs) {
        this.getJobsQueue();
      }
    }, 2000);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { location: prevLocation } = prevProps;
    if (location.pathname !== prevLocation.pathname) {
      this.setTitle(location.pathname);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    if (this.onLanguageChanged) {
      i18n.off("languageChanged", this.onLanguageChanged);
    }
  }

  loadAcl = async () => {
    const ability = await abilityPromisse();
    this.setState({ ability });
  };

  setTitle = pathname => {
    const found = findRoute(pathname);
    const route = found && found.route;
    const params = (found && found.params) || {};
    const crumbs = (route && route.crumbs) || [];

    if (crumbs.some(crumb => crumb.type === "class") && params.id) {
      localStorage.setItem("class", params.id);
    }

    this.setState(prev => ({
      crumbs,
      routeParams: params,
      classSwitchPath: (route && route.classSwitchPath) || "",
      studentName:
        params.studentId && prev.routeParams.studentId === params.studentId
          ? prev.studentName
          : ""
    }));

    if (
      pathname.startsWith("/settings") ||
      pathname.startsWith("/account/change-password")
    ) {
      this.setState({ settingsMenuOpen: true });
    }

    if (
      !params.studentId ||
      !crumbs.some(crumb => crumb.type === "studentName")
    ) {
      return;
    }

    const { studentId } = params;
    const cached = this.studentNameCache && this.studentNameCache[studentId];
    if (cached) {
      this.setState({ studentName: cached });
      return;
    }

    this.setState({ studentName: studentId });
    StudentService.getStudentById(studentId)
      .then(student => {
        const name = (student && (student.name || student.NOME)) || studentId;
        if (!this.studentNameCache) this.studentNameCache = {};
        this.studentNameCache[studentId] = name;
        const { location } = this.props;
        if (location && location.pathname === pathname) {
          this.setState({ studentName: name });
        }
      })
      .catch(() => {});
  };

  toggleSettingsMenu = () => {
    this.setState(prev => ({ settingsMenuOpen: !prev.settingsMenuOpen }));
  };

  getUserCampus = async () => {
    const res = await UserService.getUserCampus();
    this.setState({
      campuses: res,
      selectedCampus: UserStore.getCurrentCampus()
    });
  };

  changeCampus = e => {
    clearClassDirectory();
    this.setState({ selectedCampus: e.target.value });
    UserStore.setCurrentCampus(e.target.value);
    applyCampusI18nOverrides(e.target.value);
  };

  getUnreadItems = async () => {
    const {
      setCommunicationsUnread: setCommUnread,
      setNotificationsUnread: setNotUnread
    } = this.props;

    const res = await UserService.getMySessionInfos();
    const unreadItems = res.data;
    setCommUnread(unreadItems.communicationsUnread);
    setNotUnread(unreadItems.notificationsUnread);
  };

  getJobsQueue = async () => {
    const { setJobsQueue: setJobs } = this.props;
    const jobs = await JobsService.getJobQueue();
    setJobs(jobs);
    (jobs || []).forEach(job => {
      if (
        job &&
        job.name === "process_smart_minutes" &&
        job.status === "success"
      ) {
        applySmartMinutesJobWithVoice(job);
      }
    });
  };

  markJobAsRead = async jobId => {
    const {
      jobsState: { jobs },
      setJobsQueue: setJobs
    } = this.props;
    await JobsService.markAsRead(jobId);
    const foundJobIndex = jobs.findIndex(job => job.id === jobId);
    if (foundJobIndex >= 0) {
      jobs.splice(foundJobIndex, 1);
      setJobs(jobs);
    }
  };

  getPendingAck = async () => {
    await UserService.getPendingAckCommunications().then(result => {
      if (result.data.response) {
        const pendingCommunications = result.data.response;
        this.getPendingAckAttachments(pendingCommunications);
        this.setState({ pendingCommunications, openDialog: true });
      }
    });
  };

  getPendingAckAttachments = communication => {
    const communicationAttachment = communication.map(comm =>
      CommunicationService.getCommunicationAttachments(comm.id)
    );

    this.setState({ communicationAttachment });
  };

  handleLogout = () => {
    clearClassDirectory();
    UserService.logout();
  };

  onChangeAck = () => {
    const { pendingCommunications } = this.state;
    const clonePending = _.clone(pendingCommunications);
    clonePending.shift();
    this.setState({ pendingCommunications: clonePending });
  };

  getExternalInfo = async () => {
    const externalInfo = await AppService.getExternalInfo();

    localStorage.setItem("codColigada", externalInfo.codColigada);
    localStorage.setItem("codFilial", externalInfo.codFilial);
  };

  render() {
    const {
      crumbs,
      routeParams,
      classSwitchPath,
      studentName,
      campuses,
      selectedCampus,
      pendingCommunications,
      openDialog,
      communicationAttachment,
      ability,
      settingsMenuOpen
    } = this.state;
    const {
      communicationState,
      jobsState: { jobs },
      location,
      t
    } = this.props;

    if (!UserService.isAuthenticated())
      return <Login getCampuses={this.getUserCampus} />;

    if (!ability) return null;

    return (
      <AbilityContext.Provider value={ability}>
        <Can I="use module" a="diaryJobs">
          <JobsQueue queue={jobs} markAsRead={this.markJobAsRead} />
        </Can>

        {pendingCommunications && pendingCommunications.length > 0 && (
          <AckDialog
            key={pendingCommunications[0].id}
            open={openDialog}
            pendingCommunication={pendingCommunications[0]}
            onChangeAck={this.onChangeAck}
            communicationAtt={communicationAttachment}
          />
        )}
        <Toolbar
          crumbs={crumbs}
          routeParams={routeParams}
          classSwitchPath={classSwitchPath}
          studentName={studentName}
          fullWidth={Boolean(
            matchPath(location.pathname, {
              path: FULL_WIDTH_PATHS,
              exact: true
            })
          )}
          userPhoto={UserStore.getUserPhoto()}
          userName={UserStore.getUserName()}
          listMenu={(
            <List>
              {campuses && campuses.length > 1 && (
                <ListItem icon={<SchoolIcon />} button={false}>
                  <Select
                    value={selectedCampus}
                    onChange={this.changeCampus}
                    disableUnderline
                  >
                    {campuses.map(campus => (
                      <MenuItem key={campus.id} value={campus.id}>
                        {campus.name}
                      </MenuItem>
                    ))}
                  </Select>
                </ListItem>
              )}
              <ListItem icon={<HomeIcon />} component={Link} to="/">
                {t("shell.nav.home")}
              </ListItem>
              <Can I="use module" a="diaryStudents">
                <ListItem icon={<SchoolIcon />} component={Link} to="/students">
                  {t("shell.nav.students")}
                </ListItem>
              </Can>
              <Can I="use module" a="diaryCommunication">
                <ListItem
                  icon={<MailIcon />}
                  component={Link}
                  badgeNumber={communicationState.unread}
                  to="/communication"
                >
                  {t("shell.nav.communications")}
                </ListItem>
              </Can>
              <Can I="use module" a="diaryClasses">
                <ListItem
                  icon={<GroupWorkIcon />}
                  component={Link}
                  to="/classes"
                >
                  {t("shell.nav.classes")}
                </ListItem>
              </Can>
              <Can I="use module" a="diaryJobs">
                <ListItem
                  icon={<HistoryIcon />}
                  component={Link}
                  badgeNumber={jobs.length}
                  badgeDot
                  to="/solicitacoes"
                >
                  {t("shell.nav.jobRequests")}
                </ListItem>
              </Can>
              <Can I="use module" a="diaryMySchedule">
                <ListItem
                  icon={<DateRangeIcon />}
                  component={Link}
                  to="/schedule"
                >
                  {t("shell.nav.schedule")}
                </ListItem>
              </Can>
              <Can I="use module" a="diaryTeacher">
                <ListItem icon={<PeopleIcon />} component={Link} to="/teachers">
                  {t("shell.nav.teachers")}
                </ListItem>
              </Can>
              <Can I="use module" a="diarySupport">
                <ListItem icon={<ErrorIcon />} component={Link} to="/support">
                  {t("shell.nav.support")}
                </ListItem>
              </Can>
              {(ability.can("use module", "diaryAclSettings") ||
                ability.can("use module", "diaryLbSync") ||
                ability.can("use module", "diaryChangePassword") ||
                ability.can("use module", "classGeneralBoardSettings")) && (
                <>
                  <ListItem
                    icon={<SettingsIcon />}
                    onClick={this.toggleSettingsMenu}
                  >
                    <SettingsMenuLabel>
                      <SettingsMenuText>
                        {t("shell.nav.settings")}
                      </SettingsMenuText>
                      <ExpandIcon>
                        {settingsMenuOpen ? (
                          <ExpandLessIcon fontSize="small" />
                        ) : (
                          <ExpandMoreIcon fontSize="small" />
                        )}
                      </ExpandIcon>
                    </SettingsMenuLabel>
                  </ListItem>
                  <Collapse in={settingsMenuOpen} timeout="auto" unmountOnExit>
                    <Can I="use module" a="diaryChangePassword">
                      <SubMenuItem
                        icon={<LockIcon />}
                        component={Link}
                        to="/account/change-password"
                        selected={location.pathname.startsWith(
                          "/account/change-password"
                        )}
                      >
                        {t("shell.nav.changePassword")}
                      </SubMenuItem>
                    </Can>
                    <Can I="use module" a="diaryAclSettings">
                      <SubMenuItem
                        icon={<SecurityIcon />}
                        component={Link}
                        to="/settings/access-control"
                        selected={
                          location.pathname.startsWith(
                            "/settings/access-control"
                          ) ||
                          location.pathname.startsWith("/settings/class-access")
                        }
                      >
                        {t("shell.nav.accessControl")}
                      </SubMenuItem>
                    </Can>
                    <Can I="use module" a="diaryLbSync">
                      <SubMenuItem
                        icon={<SyncIcon />}
                        component={Link}
                        to="/settings/lb-sync"
                        selected={location.pathname.startsWith(
                          "/settings/lb-sync"
                        )}
                      >
                        {t("shell.nav.lbSync")}
                      </SubMenuItem>
                    </Can>
                    <Can I="use module" a="classGeneralBoardSettings">
                      <SubMenuItem
                        icon={<ViewModuleIcon />}
                        component={Link}
                        to="/settings/general-board"
                        selected={location.pathname.startsWith(
                          "/settings/general-board"
                        )}
                      >
                        {t("shell.nav.generalBoard")}
                      </SubMenuItem>
                    </Can>
                  </Collapse>
                </>
              )}
              {isClassDiaryDemo() && (
                <ListItem
                  icon={<SettingsIcon />}
                  component={Link}
                  to="/demo-settings"
                >
                  {t("shell.nav.demo")}
                </ListItem>
              )}
              <ListItem
                onClick={() => UserStore.clear()}
                icon={<ExitToAppIcon />}
                component={Link}
                to="/login"
              >
                {t("shell.nav.logout")}
              </ListItem>
              <AppVersion>{process.env.REACT_APP_VERSION}</AppVersion>
            </List>
          )}
        >
          <Switch key={location.pathname}>
            <>
              <Route exact path="/" component={Home} />
              <Can I="use module" a="diaryCommunication">
                <Route
                  exact
                  path="/communication/:id"
                  component={CommunicationDashboard}
                />
                <Route
                  exact
                  path="/communication"
                  component={CommunicationDashboard}
                />
              </Can>
              <Can I="use module" a="diaryNotification">
                <Route exact path="/notifications" component={Notifications} />
              </Can>
              <Can I="use module" a="diaryJobs">
                <Route exact path="/solicitacoes" component={JobRequests} />
              </Can>
              <Can I="use module" a="diaryClasses">
                <Route exact path="/classes" component={Classes} />
                <Route exact path="/classes/:id" component={ClassDetails} />
                <Route
                  exact
                  path="/classes/:id/overview"
                  component={ClassOverview}
                />
                <Route exact path="/classes/:id/reports" component={Reports} />
                <Route
                  exact
                  path="/classes/:id/occurrences"
                  component={Ocurrencces}
                />
                <Can I="use module" a="diaryOccurrenceAdvanced">
                  <Route
                    exact
                    path="/classes/:id/occurrencesAdvanced"
                    component={ClassOccurrencesAdvanced}
                  />
                </Can>
                <Can I="use module" a="refo">
                  <Route exact path="/classes/:id/refo" component={RefoGrid} />
                </Can>
                <Can I="use module" a="classStages">
                  <Route
                    exact
                    path="/classes/:id/stages/:stageId?"
                    component={ClassStages}
                  />
                </Can>
                <Route
                  exact
                  path="/classes/:id/grades"
                  component={ReleaseGrades}
                />
                <Route
                  exact
                  path="/classes/:id/schedule"
                  component={ClassSchedule}
                />
                <Can I="use module" a="classPlan">
                  <Route exact path="/classes/:id/plan" component={ClassPlan} />
                </Can>
                <Route
                  exact
                  path="/classes/:id/gradesV2"
                  component={ClassGradesV2}
                />
                <Route
                  exact
                  path="/classes/:id/frequency"
                  component={GridFrequency}
                />
                <Route
                  exact
                  path="/classes/:id/individualOccurrences"
                  component={IndividualOccurrences}
                />
                <Route
                  exact
                  path="/classes/:id/individualReport"
                  render={({ match }) => (
                    <Redirect
                      to={`/classes/${encodeURIComponent(
                        match.params.id
                      )}/individualReport/new`}
                    />
                  )}
                />
                <Route
                  exact
                  path="/classes/:id/individualReport/new"
                  component={IndividualReport}
                />
                <Route
                  exact
                  path="/classes/:id/individualReport/edit"
                  component={IndividualReport}
                />
                <Route
                  exact
                  path="/classes/:id/dailySummary"
                  component={DailySummaryList}
                />
                <Route
                  exact
                  path="/classes/:id/dailySummary/new"
                  component={DailySummary}
                />
                <Route
                  exact
                  path="/classes/:id/dailySummary/edit"
                  component={DailySummary}
                />
                <Route
                  exact
                  path="/classes/:id/individualOccurrences/:studentId"
                  component={StudentOccurrences}
                />
                <Can I="use module" a="smartMinutes">
                  <Route
                    exact
                    path="/classes/:id/ata-inteligente"
                    component={SmartMinutesList}
                  />
                  <Route
                    exact
                    path="/classes/:id/ata-inteligente/new"
                    component={SmartMinutes}
                  />
                  <Route
                    exact
                    path="/classes/:id/ata-inteligente/:ataId"
                    render={routeProps => {
                      if (routeProps.match.params.ataId === "new") return null;
                      return <SmartMinutesDetail {...routeProps} />;
                    }}
                  />
                </Can>
              </Can>
              <Can I="use module" a="diaryMySchedule">
                <Route exact path="/schedule" component={Schedule} />
              </Can>
              <Can I="use module" a="diaryTeacher">
                <Route exact path="/teachers" component={Teachers} />
                <Route exact path="/teachers/:id" component={TeacherDetail} />
              </Can>
              <Can I="use module" a="diarySupport">
                <Route exact path="/support" component={Support} />
              </Can>
              <Can I="use module" a="diaryAclSettings">
                <Route
                  exact
                  path="/settings"
                  render={() => <Redirect to="/settings/access-control" />}
                />
                <Route path="/settings/access-control" component={Settings} />
                <Route path="/settings/class-access" component={Settings} />
              </Can>
              <Can I="use module" a="diaryLbSync">
                <Route exact path="/settings/lb-sync" component={LbSync} />
              </Can>
              <Can I="use module" a="classGeneralBoardSettings">
                <Route
                  exact
                  path="/settings/general-board"
                  component={GeneralBoardSettings}
                />
              </Can>
              {isClassDiaryDemo() && (
                <Route exact path="/demo-settings" component={DemoSettings} />
              )}
              <Can I="use module" a="diaryChangePassword">
                <Route
                  exact
                  path="/account/change-password"
                  component={ChangePassword}
                />
              </Can>
              <Can I="use module" a="diaryStudents">
                <Route exact path="/students" component={Students} />
              </Can>
              <Can I="use module" a="diarySpecificStudent">
                <Route
                  exact
                  path="/student/:studentId"
                  component={StudentProfile}
                />
                <Can I="use module" a="diaryStudentRecord">
                  <Route
                    exact
                    path="/student/:studentId/notes"
                    component={StudentNotes}
                  />
                </Can>
                <Can I="use module" a="studentContactInfo">
                  <Route
                    exact
                    path="/student/:studentId/info"
                    component={StudentGeneralInfo}
                  />
                  <Route
                    exact
                    path="/student/:studentId/contact"
                    render={({ match }) => (
                      <Redirect
                        to={`/student/${match.params.studentId}/info`}
                      />
                    )}
                  />
                </Can>
                <Can I="use module" a="diaryStudentBulletin">
                  <Route
                    exact
                    path="/student/:studentId/statistics"
                    component={StudentStatistics}
                  />
                </Can>
                <Can I="use module" a="diaryStudentGraphics">
                  <Route
                    exact
                    path="/student/:studentId/charts"
                    component={StudentCharts}
                  />
                </Can>
                <Can I="use module" a="diaryStudentSchedule">
                  <Route
                    exact
                    path="/student/:studentId/schedule"
                    component={StudentSchedule}
                  />
                </Can>
                <Can I="use module" a="diaryStudentOccurrences">
                  <Route
                    exact
                    path="/student/:studentId/occurrences"
                    component={StudentOccurrences}
                  />
                </Can>
                <Route
                  exact
                  path="/student/:studentId/custom/:menuKey"
                  component={StudentCustomMenu}
                />
                <Can I="use module" a="reports">
                  <Route
                    exact
                    path="/student/:studentId/reports"
                    component={StudentReports}
                  />
                </Can>
                <Can I="use module" a="smartMinutes">
                  <Route
                    exact
                    path="/student/:studentId/ata-inteligente"
                    component={SmartMinutesList}
                  />
                  <Route
                    exact
                    path="/student/:studentId/ata-inteligente/new"
                    component={SmartMinutes}
                  />
                  <Route
                    exact
                    path="/student/:studentId/ata-inteligente/:ataId"
                    render={routeProps => {
                      if (routeProps.match.params.ataId === "new") return null;
                      return <SmartMinutesDetail {...routeProps} />;
                    }}
                  />
                </Can>
              </Can>
              <Route exact path="/dev/palette" component={PaletteView} />
            </>
          </Switch>
        </Toolbar>
      </AbilityContext.Provider>
    );
  }
}

App.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func
  }).isRequired, // injected by withRouter
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired, // injected by withRouter
  communicationState: PropTypes.shape({
    unread: PropTypes.number
  }).isRequired, // injected by react-redux mapStateToProps connect()
  notificationState: PropTypes.shape({
    unread: PropTypes.number
  }).isRequired, // injected by react-redux mapStateToProps connect()
  jobsState: PropTypes.arrayOf(PropTypes.shape()).isRequired, // injected by react-redux mapStateToProps connect()
  setCommunicationsUnread: PropTypes.func.isRequired, // injected by react-redux mapDispatchToProps connect()
  setNotificationsUnread: PropTypes.func.isRequired, // injected by react-redux mapDispatchToProps connect()
  setJobsQueue: PropTypes.func.isRequired, // injected by react-redux mapDispatchToProps connect()
  t: PropTypes.func.isRequired // injected by withTranslation
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { setCommunicationsUnread, setNotificationsUnread, setJobsQueue },
    dispatch
  );

const mapStateToProps = state => ({
  communicationState: state.communicationState,
  notificationState: state.notificationState,
  jobsState: state.jobsState
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(App)));
